import decodeJwt from "jwt-decode";

export const useRoleIdentifier = {
  methods: {
    userHasPermission(item = {}) {
      if (!item.onlyVipRoles) {
        return true;
      }
      return !!this.checkVipRole();
    },
    checkVipRole(currentRole = null) {
      if (!currentRole) {
        const token = localStorage.getItem("token");
        currentRole = decodeJwt(token).role;
      }
      const vipRoles = ["администратор", "владелец", "руководитель"];
      return !!vipRoles.includes(currentRole);
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useRoleIdentifier.js